import { SvgIcon } from '@mui/material';
import React, { CSSProperties, ReactElement } from 'react';

export interface ExportDownloadIconProps {
  style?: CSSProperties;
}

export const ExportDownloadIcon = ({
  style,
}: ExportDownloadIconProps): ReactElement => {
  return (
    <SvgIcon
      style={{
        fontSize: '1em',
        color: '#383838',
        ...style,
      }}
      viewBox="0 0 14 14"
    >
      <path
        d="M7 10.577L3.4615 7.0385L4.16925 6.31925L6.5 8.65V0H7.5V8.65L9.83075 6.31925L10.5385 7.0385L7 10.577ZM1.6155 14C1.15517 14 0.770833 13.8458 0.4625 13.5375C0.154167 13.2292 0 12.8448 0 12.3845V9.9615H1V12.3845C1 12.5385 1.06408 12.6796 1.19225 12.8077C1.32042 12.9359 1.4615 13 1.6155 13H12.3845C12.5385 13 12.6796 12.9359 12.8077 12.8077C12.9359 12.6796 13 12.5385 13 12.3845V9.9615H14V12.3845C14 12.8448 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8448 14 12.3845 14H1.6155Z"
        fill="#383838"
      />
    </SvgIcon>
  );
};


